export const DESKTOP_MIN_WIDTH = 1024
export const MOBILE_MAX_WIDTH = 860
